// src/client/hooks/useRepayment.ts
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { paymentService, type InitiateRepaymentInput } from '@client/services';
import { ServiceError } from '@client/lib/serviceError';

export function useInitiateRepayment() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (input: InitiateRepaymentInput) => {
      const r = await paymentService.initiateRepayment(input);
      if (!r.ok) throw new ServiceError(r.error);
      return r.value;
    },
    onSuccess: () => {
      // Per CLAUDE.md: "Score recalculated after every payment, loan completion,
      // KYC change." Invalidate both loans and credit-score so the Home screen
      // refreshes outstanding balance AND the score gauge after repayment.
      // React Query 5 prefix-matches: ['client','loans'] covers
      // ['client','loans','active'|'history'], same for ['client','credit-score'].
      void qc.invalidateQueries({ queryKey: ['client', 'loans'] });
      void qc.invalidateQueries({ queryKey: ['client', 'credit-score'] });
    },
  });
}
